<template>
  <div id="tabTeams">
    <div class="margin-subpages">
      <div>
        <div class="flex-row-center">
          <div class="flex-center-1 fs-24 f-000000">
            <span class="fw-900">{{
              teamsall.length > 0
                ? $utils("addCommasInNumber", teamsall.length)
                : 0
            }}</span>
            <span class="fw-600">&nbsp;{{ $t("members.Teams") }}</span>
            <span
              v-if="teamDuplicate.status"
              class="tag-pill tag-pill--md tag-pill--cased tag-pill--danger duplicate-pill"
              >{{ teamDuplicate.count }}
              {{ $t("members.duplicate_teams") }}</span
            >
          </div>
          <div class="flex-row-center" style="gap: 8px;">
            <el-button
              @click="showAudit"
              class="btn-secondary"
              size="small"
              >AUDIT TEAMS</el-button
            >
            <el-button
              @click="addTeam"
              class="btn-primary-purple"
              size="small"
              icon="el-icon-plus"
              >{{ $t("members.ADD_TEAM") }}</el-button
            >
          </div>
        </div>
        <div class="flex-row-between mt-24">
          <el-input
            class="input-style"
            style="font-size: 14px; height: 40px"
            autosize
            :placeholder="$t('members.Search')"
            v-model="inputSearch"
            clearable
          ></el-input>
          <div style="width: 220px">
            <el-menu class="input-select" mode="horizontal">
              <el-submenu index="0" style="width: 220px">
                <template slot="title">
                  <span class="text-dropdown" id="sortby">{{
                    $t("members.Sort_by_Name")
                  }}</span>
                </template>
                <el-menu-item
                  index="1"
                  @click="sortBy('name')"
                  style="font-size: 14px; width: 220px"
                  >{{ $t("members.Sort_by_Name") }}</el-menu-item
                >
                <el-menu-item
                  index="2"
                  @click="sortBy('parent')"
                  style="font-size: 14px; width: 220px"
                  >{{ $t("members.Sort_by_Parent") }}</el-menu-item
                >
              </el-submenu>
            </el-menu>
          </div>
        </div>
        <div class="mt-24">
          <div class="opa-04" v-if="loadingTeamsTable">
            <div
              v-for="item in [1, 2, 3, 4]"
              :key="'mock_team_' + item"
              :class="{
                'opa-02': item == 4,
                'opa-04': item == 3,
                'opa-06': item == 2,
              }"
              class="grid-4"
            >
              <div
                class="team-sitebar"
                style="background: #747474; opacity: 0.4"
              ></div>
              <div class="px-24 flex-center">
                <div class="fw-700 fs-17 text-skeleton" style="width: 90px">
                  &nbsp;
                </div>
              </div>
              <div class="px-24 flex-center">
                <div class="flex-row-center">
                  <div class="image-skeleton image-profile-42 opa-06"></div>
                  <div class="flex-column" style="padding-left: 8px">
                    <div class="fw-700 fs-12 text-skeleton" style="width: 80px">
                      &nbsp;
                    </div>
                    <div
                      class="fw-700 fs-12 text-skeleton opa-06 mt-4"
                      style="width: 90px"
                    >
                      &nbsp;
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-24 flex-center">
                <div class="flex-column">
                  <div
                    class="fw-700 fs-10 text-skeleton opa-04"
                    style="width: 50px"
                  >
                    &nbsp;
                  </div>
                  <div class="flex-row-center mt-4">
                    <div class="opa-04" style="display: flex">
                      <div
                        v-for="index in [1, 2, 3, 4]"
                        :key="index + '_mock_user'"
                      >
                        <div v-if="index < 7">
                          <div>
                            <div
                              class="image-skeleton image-profile-32"
                              :style="renderMemberPic(index)"
                            ></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="px-24 flex-center">
                <div class="flex-column">
                  <div
                    class="fw-700 fs-12 text-skeleton opa-05"
                    style="width: 80px"
                  >
                    &nbsp;
                  </div>
                  <div
                    class="fw-700 fs-15 text-skeleton mt-4"
                    style="width: 120px"
                  >
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-for="item in teams"
            :key="item.key"
            :class="{ duplicateStyle: item.duplicate }"
            class="grid-4 cursor-pointer"
            @click="editTeam(item)"
          >
            <div
              class="team-sitebar"
              v-bind:style="teamBarStyleFunc(item.color)"
            ></div>
            <div class="px-24 flex-center">
              <span class="fw-700 fs-17 fc-000000 ellipsis"
              :class="[ blurMode ?  'blurelement': '' ]">{{
                item.name
              }}</span>
            </div>
            <div class="px-24 flex-center">
              <div v-if="item.multiple == true" class="flex-row-center">
                <div>
                  <img
                    :src="$utils('icons', 'ic_multiple_managers')"
                    alt="icons_ic_multiple_managers"
                    class="image-skeleton image-profile-42"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div class="flex-column" style="padding-left: 8px">
                  <span class="text-name">{{"Multiple Managers"}}</span>
                  <span class="text-email">{{
                    $t("members.Team_Manager")
                  }}</span>
                </div>
              </div>
              <div v-else class="flex-row-center">
                <div v-if="item.pic">
                  <img
                    v-lazy="item.pic"
                    :key="item.pic"
                    class="image-skeleton image-profile-42"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div v-else class="image image-profile-42"
                :class="[
                  $utils('avatarTone', { firstName: item.boss_firstname, lastName: item.boss_lastname }),
                  blurMode ? 'blurelement' : ''
                ]">
                  <div class="flex-mid text-in-image text-in-image-42">
                    {{
                      $utils("acronymName", {
                        firstName: item.boss_firstname,
                        lastName: item.boss_lastname,
                      })
                    }}
                  </div>
                </div>
                <div class="flex-column" style="padding-left: 8px">
                  <span class="text-name"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    item.boss_firstname
                      ? item.boss_firstname + " " + item.boss_lastname.charAt(0)
                      : "Unassigned"
                  }}</span>
                  <span class="text-email"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    $t("members.Team_Manager")
                  }}</span>
                </div>
              </div>
            </div>
            <div class="px-24 flex-center">
              <div class="flex-column">
                <span class="fc-4A4A4A fs-12"
                  >{{ item.sup ? item.sup.length : 0 }}
                  {{ $t("members.Members") }}</span
                >
                <div class="flex-row-center mt-2">
                  <div v-if="item.sup" style="display: flex">
                    <div v-for="(manager, index) in item.sup" :key="index">
                      <div v-if="index < 7">
                        <div v-if="manager.pic">
                          <img
                            v-lazy="manager.pic"
                            :key="manager.pic"
                            class="image-skeleton image-profile-32"
                            :class="[ blurMode ?  'blurelement': '' ]"
                            :style="renderMemberPic(index)"
                          />
                        </div>
                        <div
                          v-else
                          class="image image-profile-32"
                          :class="[
                            $utils('avatarTone', { firstName: manager.firstname, lastName: manager.lastname }),
                            blurMode ? 'blurelement' : ''
                          ]"
                          :style="renderMemberPic(index)"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                firstName: manager.firstname,
                                lastName: manager.lastname,
                              })
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        v-if="index == 7"
                        class="image image-profile-32 overflow-chip"
                        :style="renderMemberPic(index)"
                      >
                        <div
                          class="text-in-image text-in-image-42 flex-mid"
                          :style="`font-weight: 700; font-size: ${
                            item.sup.length < 99
                              ? '13'
                              : item.sup.length < 999
                              ? '11'
                              : '9'
                          }px;`"
                        >
                          {{
                            item.sup.length > 7
                              ? "+" + (item.sup.length - 7)
                              : ""
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <span
                    class="fw-700 fs-14 fc-4A4A4A"
                    style="margin-left: -53px;"
                  >{{ (item.sup && item.sup.length > 7) ? "+"+(item.sup.length - 7) : "" }}</span> -->
                </div>
              </div>
            </div>
            <div class="px-24 flex-center">
              <div class="flex-column">
                <span class="fc-4A4A4A fs-12">{{
                  $t("members.Parent_Team")
                }}</span>
                <span v-if="item.parent_name" class="fs-16 fw-700 fc-4A4A4A"
                :class="[ blurMode ?  'blurelement': '' ]">{{
                  item.parent_name
                }}</span>
                <span v-else
                :class="[ blurMode ?  'blurelement': '' ]">&nbsp;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-20 pagination flex-center" v-if="!loadingTeamsTable">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="results"
        ></el-pagination>
        <span class="results-status">
          {{ results > 10 ? 10 : results }} {{ $t("members.results_from") }}
          {{ $utils("addCommasInNumber", results) }} {{ $t("members.results") }}
        </span>
      </div>
    </div>

    <el-dialog
      :visible.sync="dialogFormVisible"
      top="8vh"
      :before-close="handleFormDialogClose"
      custom-class="tm-modal"
      @closed="resetTeamForm"
    >
      <div
        class="sidebar-modal-color"
        v-bind:class="renderSidebarColorFunc(modalForm.color)"
      ></div>
      <el-form :model="modalForm" ref="modalForm">
        <el-col :span="11" class="first-column profileform">
          <div
            style="padding-top: 36px; padding-left: 40px; padding-right: 40px; padding-bottom: 24px"
          >
            <el-col :span="24">
              <p class="txtHeaderStyle">{{ $t("members.Team_Name") }}</p>
              <el-input
                class="team-field"
                auto-complete="off"
                :placeholder="$t('members.Team_Name')"
                v-model="modalForm.team_name"
                :class="[ blurMode ?  'blurelement': '' ]"
              ></el-input>
            </el-col>
            <el-col :span="24" style="padding-top: 18px">
              <a
                class="goals-shortcut"
                href="#"
                @click.prevent="openGoalsView"
              >
                <span>Manage team goals in Goals</span>
                <span class="goals-shortcut-arrow" aria-hidden="true">→</span>
              </a>
            </el-col>
            <el-col :span="24" style="padding-top: 18px">
              <p class="txtHeaderStyle">{{ $t("members.Parent_Team") }}</p>
              <el-autocomplete
                class="inline-input team-parent-field"
                v-bind:class="[
                  renderParentSidebarColorFunc(modalForm.parent_color),
                  blurMode ? 'blurelement' : ''
                ]"
                v-model="modalForm.dispteam_parent"
                :fetch-suggestions="querySearchTeam"
                :placeholder="$t('members.Auto_assignment')"
                :trigger-on-focus="true"
                clearable
                @select="handleSelectTeam"
                @clear="handleParentClear"
                @blur="handleParentBlur"
                style="width: 100%"
              >
                <template slot-scope="{ item }">
                  <div class="parent-suggestion">
                    <span
                      class="parent-suggestion-dot"
                      :style="{ background: item.color || '#c4c4c4' }"
                    ></span>
                    <span class="parent-suggestion-name">{{ item.name }}</span>
                  </div>
                </template>
              </el-autocomplete>
              <p v-if="modalForm.parent_id" class="parent-hint">
                Reassign by selecting a different team, or clear to make this a top-level team.
              </p>
              <p v-else class="parent-hint">
                This team has no parent. Pick one from the list to nest it.
              </p>
            </el-col>
            <el-col :span="24" style="padding-top: 18px">
              <p class="txtHeaderStyle">{{ $t("members.Managers") }}</p>
              <div v-if="modalForm.multiple == true" class="flex-row-center" style="padding-top: 8px">
                <div>
                  <img
                    :src="$utils('icons', 'ic_multiple_managers')"
                    alt="icons_ic_multiple_managers"
                    class="image-skeleton image-profile-52"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    padding-left: 16px;
                  "
                >
                  <span class="fs-18 fc-000000">{{"Multiple Managers"}}</span>
                </div>
              </div>
              <div v-else class="flex-row-center" style="padding-top: 8px">
                <div v-if="modalForm.parent_pic">
                  <img
                    v-lazy="modalForm.parent_pic"
                    :key="modalForm.parent_pic"
                    class="image-skeleton image-profile-52"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                </div>
                <div v-else class="image image-profile-52"
                :class="[
                  $utils('avatarTone', { fullName: modalForm.boss_name }),
                  blurMode ? 'blurelement' : ''
                ]">
                  <div class="text-in-image text-in-image-52 flex-mid">
                    {{
                      $utils("acronymName", { fullName: modalForm.boss_name })
                    }}
                  </div>
                </div>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    padding-left: 16px;
                  "
                >
                  <span class="fs-18 fc-000000"
                  :class="[ blurMode ?  'blurelement': '' ]">{{
                    modalForm.boss_name
                      ? modalForm.boss_name
                      : "Auto-assignment"
                  }}</span>
                </div>
              </div>
            </el-col>
            <el-col
              v-if="modalForm.mode && modalForm.child_teams.length"
              :span="24"
              style="padding-top: 20px"
            >
              <p class="txtHeaderStyle">
                Sub-teams ({{ modalForm.child_teams.length }})
              </p>
              <div class="child-teams-list">
                <div
                  v-for="child in modalForm.child_teams"
                  :key="child.key"
                  class="child-team-chip"
                >
                  <span
                    class="child-team-dot"
                    :style="{ background: child.color || '#c4c4c4' }"
                  ></span>
                  <span
                    class="child-team-name"
                    :class="[blurMode ? 'blurelement' : '']"
                  >
                    {{ child.name }}
                  </span>
                </div>
              </div>
              <p class="parent-hint">
                Reassign sub-teams to a different parent before deleting.
              </p>
            </el-col>
            <el-col :span="24" style="padding-top: 20px">
              <p class="txtHeaderStyle">{{ $t("members.Color_Tag") }}</p>
              <div class="color-tag-swatches">
                <div
                  v-for="(color, index) in tagColorMaster"
                  :key="index"
                  class="tagColor"
                  @click="tagColorCheckFunc(index, color)"
                  v-bind:class="[
                    {
                      'active-check':
                        modalForm.selectedColorForUpdate === index,
                    },
                    `bg-${color}`,
                  ]"
                ></div>
              </div>
            </el-col>
            <el-col
              :span="24"
              style="padding-top: 32px; display: flex; align-items: center"
            >
              <el-button
                class="btnAddTeamModal"
                :loading="savingTeam"
                :disabled="savingTeam"
                @click="saveTeam"
              >{{
                modalForm.mode
                  ? $t("members.SAVE_CHANGES")
                  : $t("members.CREATE_TEAM")
              }}</el-button>
              <el-button
                v-if="modalForm.mode"
                :disabled="modalForm.sup.length > 0 || modalForm.child_teams.length > 0"
                class="btnCancelTeamModal btn-gray"
                type="primary"
                @click="deleteTeam"
                >{{ $t("members.DELETE") }}</el-button
              >
              <el-button
                v-else
                class="btnCancelTeamModal btn-gray"
                type="primary"
                @click="dialogFormVisible = false"
                >{{ $t("members.CANCEL") }}</el-button
              >
            </el-col>
            <el-col :span="24" style="padding-top: 16px">
              <div class="flex-center">
                <p class="txtHeaderStyle">Internal Value</p>
                <el-tooltip placement="top">
                  <div slot="content">
                    <div class="flex-mid ml-auto fs-11" style="width: 210px">
                      This unique identifier will be used when syncing with
                      integration partners. Once created it can’t be edited.
                    </div>
                  </div>
                  <img
                    :src="$utils('icons', 'ic_help_outline-16px')"
                    alt="icons_ic_help_outline-16px"
                    class="ml-12 pb-8"
                  />
                </el-tooltip>
              </div>
              <div
                @click="copyURL(modalForm.internal_id)"
                class="style-internal-value flex-center"
              >
                {{ modalForm.internal_id }}
              </div>
            </el-col>
          </div>
        </el-col>
        <el-col :span="13" class="second-column">
          <div v-if="!modalForm.mode" class="px-40" style="padding-top: 60px">
            <el-col :span="24" style="padding-top: 35px">
              <span class="guideTextModal">{{
                $t("members.A_unique_team_name")
              }}</span>
            </el-col>
            <el-col :span="24" style="padding-top: 75px">
              <span class="guideTextModal">{{
                $t("members.A_parent_team_and")
              }}</span>
            </el-col>
            <el-col :span="24" style="padding-top: 185px">
              <span class="guideTextModal">{{
                $t("members.Select_a_color_tag")
              }}</span>
            </el-col>
          </div>
          <div v-else class="px-40" style="padding-top: 60px">
            <span class="fc-000000 fs-20 fw-900"
              >{{ modalForm.sup ? modalForm.sup.length : 0 }}
              {{ $t("members.members") }}</span
            >
            <div style="">
              <el-table
                :data="modalForm.sup"
                style="width: 100%"
                :empty-text="$t('members.No_team_members')"
                max-height="760px"
                class="el-table-thin-scrollbar"
              >
                <el-table-column width="58">
                  <template slot-scope="scope">
                    <div class="divMember">
                      <div v-if="scope.row.pic">
                        <img
                          v-lazy="scope.row.pic"
                          :key="scope.row.pic"
                          style="
                            display: flex;
                            align-items: center;
                            justify-content: center;
                          "
                          class="image-skeleton image-profile-42"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                      </div>
                      <div v-else class="image image-profile-42"
                      :class="[
                        $utils('avatarTone', { firstName: scope.row.firstname, lastName: scope.row.lastname }),
                        blurMode ? 'blurelement' : ''
                      ]">
                        <div class="text-in-image text-in-image-42 flex-mid">
                          {{
                            $utils("acronymName", {
                              firstName: scope.row.firstname,
                              lastName: scope.row.lastname,
                            })
                          }}
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('members.Members')" width="180">
                  <template slot-scope="scope">
                    <div style="display: flex; flex-direction: column">
                      <span class="text-name"
                      :class="[ blurMode ?  'blurelement': '' ]"
                        >{{ scope.row.firstname }}
                        {{ scope.row.lastname }}</span
                      >
                      <span class="text-email"
                      :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.email }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('members.Team')" width="170">
                  <template slot-scope="scope">
                    <span class="fc4A4A4A fs-14 ellipsis"
                    :class="[ blurMode ?  'blurelement': '' ]">{{
                      scope.row.team_name
                    }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$t('members.Status')"
                  align="center"
                  width="90"
                >
                  <template slot-scope="scope">
                    <div class="div-active">
                      <div
                        class="btn-status"
                        :class="[`status-${scope.row.status}`]"
                      >
                        {{ scope.row.status }}
                      </div>
                      <div class="active">{{ scope.row.to_now }}</div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-col>
      </el-form>
    </el-dialog>

    <!-- Team Audit Dialog -->
    <el-dialog
      :visible.sync="auditDialogVisible"
      :fullscreen="true"
      :close-on-press-escape="true"
    >
      <template slot="title">
        <!-- <div style="display: flex; align-items: center; justify-content: space-between;">
          <span style="font-size: 20px; font-weight: 700;">Team Relationship Audit</span>
          <el-button
            type="text"
            @click="auditDialogVisible = false"
            style="font-size: 24px; padding: 0;"
          >
            <i class="el-icon-close"></i>
          </el-button>
        </div> -->
      </template>
      <team-audit v-if="auditDialogVisible" />
    </el-dialog>
  </div>
</template>

<script>
import TeamAudit from "./members-components/team-audit.vue";

export default {
  name: "teams",
  components: {
    TeamAudit
  },
  created() {
    this.loadTeamsData();
    this.rootAddTeamHandler = () => this.addTeam();
    this.$root.$on('addTeam', this.rootAddTeamHandler);
  },
  beforeDestroy() {
    if (this.rootAddTeamHandler) {
      this.$root.$off('addTeam', this.rootAddTeamHandler);
    }
  },
  computed: {
    inputSearch: {
      get() {
        return this.$store.getters["newteam/inputSearch"];
      },
      set(value) {
        this.$store.commit("newteam/setinputSearch", { value });
      },
    },
    user() {
      return this.$store.getters["authen/user"];
    },
    teams() {
      return this.$store.getters["newteam/teams"];
    },
    teamsall() {
      return this.$store.getters["newteam/teamsall"];
    },
    page() {
      return this.$store.getters["newteam/page"];
    },
    results() {
      return this.$store.getters["newteam/results"];
    },
    teamDuplicate() {
      return this.$store.getters["newteam/teamDuplicate"];
    },
    loadingTeamsTable() {
      return this.$store.getters["newteam/loadingTeamsTable"];
    },
    teamRandomNumber() {
      return this.$store.getters["newteam/teamRandomNumber"];
    },
    updateMember() {
      return this.$store.getters["newmember/updateMember"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  watch: {
    inputSearch() {
      this.$store.dispatch("newteam/searchTeams", this.inputSearch);
    },
    teamRandomNumber(){
      if(this.teamRandomNumber){
        this.modalForm.internal_id = this.teamRandomNumber
        this.$nextTick(() => this.captureFormSnapshot());
      }
    }
  },
  data() {
    return {
      formLabelWidth: "140px",
      dialogFormVisible: false,
      auditDialogVisible: false,
      savingTeam: false,
      activeIndex: "1",
      id: "",
      mode: "",
      team: "",
      team_name: "",
      dispteam_parent: "",
      current_page: 1,
      modalForm: {
        id: "",
        mode: "",
        team_name: "",
        team_goals: "",
        dispteam_parent: "",
        parent_id: "",
        parent_color: "",
        parent_pic: "",
        sup: [],
        boss_name: "",
        color: "#6C30CC",
        selectedColorForUpdate: 0,
        child_teams: [],
        internal_id: "",
        multiple: false,
      },
      modalFormSnapshot: null,
      tagColorMaster: [
        "6C30CC",
        "4F86C6",
        "50B0C6",
        "379392",
        "68D5B5",
        "EE7885",
        "C99EC4",
        "84B1ED",
        "31AADE",
        "F0DC05",
        "E63A40",
      ],
    };
  },
  methods: {
    async loadTeamsData() {
      if (this.updateMember == true) {
        await this.$store.dispatch("main/getuser", true);
      }
      await this.$store.dispatch("newteam/getOrganization");
      await this.$store.dispatch("newteam/getTeams", this.user);
      this.$store.commit("authen/setActiveIndex", "3");
    },
    copyURL(value) {
      const clipboardData = window.clipboardData || navigator.clipboard;

      try {
        clipboardData.writeText(value);
        // Show a success message
        this.$message({
          message: `Copy ID to clipboard.`,
          type: "success",
        });
      } catch (error) {
        // Handle any errors
        console.error("Error copying ID to clipboard:", error);

        // Show an error message
        this.$message({
          message: `Failed to copy ID to clipboard.`,
          type: "error",
        });
      }
    },
    saveTeam() {
      if (this.savingTeam) {
        return false;
      }
      if (!this.modalForm.team_name.replace(/ /g, "")) {
        this.$message({
          showClose: true,
          message: "Valid Team Name required.",
          type: "error",
        });
        return false;
      }
      const isEdit = this.modalForm.mode === "edit";
      const snapshot = this.modalFormSnapshot || {};
      const parentChanged =
        isEdit && (snapshot.parent_id || "") !== (this.modalForm.parent_id || "");
      const proceed = parentChanged
        ? this.confirmParentChange(snapshot)
        : Promise.resolve();
      proceed.then(() => this.persistTeam()).catch(() => {
        // User chose to keep editing — no action.
      });
    },
    confirmParentChange(snapshot) {
      const escape = (s) =>
        String(s == null ? "" : s)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&#39;");
      const teamName = escape(this.modalForm.team_name);
      const oldParent = (snapshot && snapshot.dispteam_parent) || "";
      const newParent = this.modalForm.dispteam_parent || "";
      const oldLabel = oldParent
        ? `<strong>${escape(oldParent)}</strong>`
        : "<em>no parent (top-level)</em>";
      const newLabel = newParent
        ? `<strong>${escape(newParent)}</strong>`
        : "<em>no parent (top-level)</em>";
      const html = `
        <div style="font-size:13px; line-height:1.55; color:#1f2330;">
          <p style="margin:0 0 10px 0;">
            You're reassigning <strong>${teamName}</strong> from
            ${oldLabel} to ${newLabel}.
          </p>
          <p style="margin:0 0 6px 0; font-weight:600;">This will affect:</p>
          <ul style="margin:0 0 10px 18px; padding:0;">
            <li>Reports and email digests that roll up by team hierarchy.</li>
            <li>Permissions and visibility inherited from the parent's leadership.</li>
            <li>Org-chart placement for this team and any of its sub-teams.</li>
          </ul>
          <p style="margin:0; color:#6b7280; font-size:12px;">
            Past reports already delivered won't change. Future ones will use the new structure.
          </p>
        </div>
      `;
      return this.$confirm(html, "Reassign parent team?", {
        dangerouslyUseHTMLString: true,
        confirmButtonText: "Reassign",
        cancelButtonText: "Keep editing",
        type: "warning",
      });
    },
    async persistTeam() {
      const isEdit = this.modalForm.mode == "edit";
      if (isEdit && !(this.modalForm.id || "").toString().trim()) {
        this.$message({
          type: "error",
          message: "Could not update team: missing team id.",
        });
        return;
      }
      // Clone before await so dialog close / resetTeamForm cannot mutate the
      // payload mid-flight into an empty /team root write.
      const formPayload = _.cloneDeep(this.modalForm);
      this.savingTeam = true;
      try {
        await this.$store.dispatch(
          isEdit ? "newteam/updateTeam" : "newteam/createTeam",
          formPayload
        );
        this.update_success();
      } catch (error) {
        console.error("Error saving team:", error);
        this.$message({
          type: "error",
          message: isEdit
            ? "Could not update team. Please try again."
            : "Could not create team. Please try again.",
        });
      } finally {
        this.savingTeam = false;
      }
    },
    addTeam() {
      this.cancelAdd();
      this.$store.dispatch("newteam/generateTeamRandomNumber");
      this.dialogFormVisible = true;
    },
    showAudit() {
      this.auditDialogVisible = true;
    },
    openGoalsView() {
      const teamId = this.modalForm.id;
      const route = this.$router.resolve({
        name: "performance",
        params: { tab: "goals" },
        query: teamId ? { team: teamId } : {},
      });
      window.open(route.href, "_blank", "noopener");
    },
    editTeam(item) {
      this.modalForm.child_teams = _.filter(this.teamsall, {
        parent: item.key,
      }).map((t) => ({
        key: t.key,
        name: t.name,
        color: t.color || "",
      }));
      this.modalForm.mode = "edit";
      this.modalForm.id = item.key;
      this.modalForm.team_name = item.name;
      this.modalForm.team_goals = item.goals || "";
      this.modalForm.dispteam_parent = item.parent_name || "";
      this.modalForm.parent_id = item.parent || "";
      this.modalForm.parent_color = item.parent_color || "";
      this.modalForm.parent_pic = item.pic;
      this.modalForm.sup = item.sup;
      if (item.boss_firstname) {
        this.modalForm.boss_name =
          item.boss_firstname + " " + item.boss_lastname;
      } else {
        this.modalForm.boss_name = "";
      }

      this.modalForm.color = item.color;
      this.modalForm.parent_color = item.parent_color;
      let colorCode = null;
      if (item.color) {
        colorCode = item.color.replace(/#/g, "");
      }
      this.modalForm.selectedColorForUpdate =
        this.tagColorMaster.indexOf(colorCode);
      this.modalForm.internal_id = item.internal_id;
      this.modalForm.multiple = (item.multiple) ? item.multiple : false;
      this.dialogFormVisible = true;
      this.$nextTick(() => this.captureFormSnapshot());
    },
    resetTeamForm() {
      this.modalForm.mode = "";
      this.modalForm.id = "";
      this.modalForm.team_name = "";
      this.modalForm.team_goals = "";
      this.modalForm.dispteam_parent = "";
      this.modalForm.parent_id = "";
      this.modalForm.parent_color = "";
      this.modalForm.parent_pic = "";
      this.modalForm.sup = [];
      this.modalForm.boss_name = "";
      this.modalForm.color = "#6C30CC";
      this.modalForm.selectedColorForUpdate = 0;
      this.modalForm.child_teams = [];
      this.modalForm.internal_id = "";
      this.modalForm.multiple = false;
      this.modalFormSnapshot = null;
      this.savingTeam = false;
    },
    cancelAdd() {
      this.resetTeamForm();
      this.dialogFormVisible = false;
    },
    captureFormSnapshot() {
      this.modalFormSnapshot = _.cloneDeep(this.modalForm);
    },
    isFormDirty() {
      if (!this.modalFormSnapshot) return false;
      return !_.isEqual(this.modalForm, this.modalFormSnapshot);
    },
    handleFormDialogClose(done) {
      if (this.savingTeam) {
        return;
      }
      if (!this.isFormDirty()) {
        done();
        return;
      }
      this.$confirm(
        "You have unsaved changes. Discard them?",
        "Unsaved changes",
        {
          confirmButtonText: "Discard",
          cancelButtonText: "Keep editing",
          type: "warning",
        }
      )
        .then(() => done())
        .catch(() => {});
    },
    update_success() {
      let message = "Create success";
      if (this.modalForm.mode == "edit") {
        message = "Team Info Updated";
      }
      this.modalFormSnapshot = null;
      this.dialogFormVisible = false;
      this.$message({
        type: "success",
        message,
      });
      this.refreshMemberTeamData();
    },
    refreshMemberTeamData() {
      this.$store.dispatch("newmember/getTeamAll", this.user);
      this.$store.dispatch("newmember/getMember", this.user);
      this.$store.dispatch("membermanager/getMemberManager", this.user);
    },
    async deleteTeam() {
      try {
        await this.$confirm(
          `Are you sure to delete <strong>${this.modalForm.team_name}</strong>?`,
          "Warning",
          {
            dangerouslyUseHTMLString: true,
            confirmButtonText: "Sure",
            cancelButtonText: "Cancel",
            type: "warning",
          }
        );
        await this.$store.dispatch("newteam/deleteTeam", this.modalForm.id);
        this.cancelAdd();
        this.$message({
          type: "success",
          message: "Delete completed",
        });
        this.refreshMemberTeamData();
      } catch (error) {
        if (error === "cancel" || error === "close") {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
          return;
        }
        console.error("Error deleting team:", error);
        this.$message({
          type: "error",
          message: "Could not delete team. Please try again.",
        });
      }
    },
    handleSelectTeam(item) {
      if (!item || !item.key) return;
      // Block self-assignment and cycles defensively (also filtered upstream).
      if (item.key === this.modalForm.id) {
        this.revertParentDisplay();
        return;
      }
      if (this.isTeamDescendant(item.key, this.modalForm.id)) {
        this.revertParentDisplay();
        this.$message({
          type: "warning",
          message: "That team is a descendant of this one — pick a different parent.",
        });
        return;
      }
      this.modalForm.parent_id = item.key;
      this.modalForm.dispteam_parent = item.name;
      this.modalForm.parent_color = item.color || "";
    },
    handleParentClear() {
      this.modalForm.parent_id = "";
      this.modalForm.parent_color = "";
      this.modalForm.dispteam_parent = "";
    },
    handleParentBlur() {
      // Allow a small delay so a click-to-select on a suggestion can land first.
      setTimeout(() => {
        const typed = (this.modalForm.dispteam_parent || "").trim();
        if (!typed) {
          this.handleParentClear();
          return;
        }
        const exact = this.teamsall.find(
          (t) => t.name && t.name.toLowerCase() === typed.toLowerCase()
        );
        if (exact && exact.key !== this.modalForm.id && !this.isTeamDescendant(exact.key, this.modalForm.id)) {
          this.modalForm.parent_id = exact.key;
          this.modalForm.dispteam_parent = exact.name;
          this.modalForm.parent_color = exact.color || "";
          return;
        }
        // Typed text doesn't resolve to a valid team — restore last known.
        this.revertParentDisplay();
      }, 150);
    },
    revertParentDisplay() {
      const id = this.modalForm.parent_id;
      if (!id) {
        this.modalForm.dispteam_parent = "";
        this.modalForm.parent_color = "";
        return;
      }
      const found = this.teamsall.find((t) => t.key === id);
      this.modalForm.dispteam_parent = found ? found.name : "";
      this.modalForm.parent_color = found && found.color ? found.color : "";
    },
    querySearchTeam(queryString, cb) {
      const currentId = this.modalForm.id;
      const eligible = this.teamsall.filter(
        (t) =>
          t.key &&
          t.key !== currentId &&
          !this.isTeamDescendant(t.key, currentId)
      );
      const results = queryString
        ? eligible.filter(this.createFilterTeam(queryString))
        : eligible;
      cb(results);
    },
    createFilterTeam(queryString) {
      const q = queryString.toLowerCase();
      return (link) => {
        if (!link.name) return false;
        return link.name.toLowerCase().includes(q);
      };
    },
    isTeamDescendant(candidateKey, ancestorKey) {
      // Returns true if `candidateKey` is `ancestorKey` itself or a descendant of it.
      if (!candidateKey || !ancestorKey) return false;
      const seen = new Set();
      let cursor = candidateKey;
      while (cursor && !seen.has(cursor)) {
        if (cursor === ancestorKey) return true;
        seen.add(cursor);
        const node = this.teamsall.find((t) => t.key === cursor);
        cursor = node && node.parent ? node.parent : null;
      }
      return false;
    },
    handleCurrentChange(val) {
      this.current_page = val;
      this.$store.dispatch("newteam/currentChange", val);
    },
    sortBy(type) {
      if (type == "name") {
        document.getElementById("sortby").innerHTML = "Sort by Name";
      } else if (type == "parent") {
        document.getElementById("sortby").innerHTML = "Sort by Parent";
      }
      this.$store.dispatch("newteam/sortBy", type);
    },
    tableRowStyle({ row, rowIndex }) {
      if (row.duplicate) {
        return "background: #FEEAE9;";
      }
    },
    teamBarStyleFunc(color) {
      if (color) {
        return "background: " + color;
      } else {
        return "background:#747474;";
      }
    },
    tagColorCheckFunc(index, color) {
      this.modalForm.selectedColorForUpdate = index;
      this.modalForm.color = "#" + color;
    },
    renderSidebarColorFunc(code) {
      if (code) {
        let color = code.replace(/#/g, "");
        return `bg-${color}`;
      } else {
        return "bg-747474";
      }
    },
    renderParentSidebarColorFunc(code) {
      if (code) {
        let color = code.replace(/#/g, "");
        return `border-left-color-${color}`;
      } else {
        return `border-left-color-`;
      }
    },
    renderMemberPic(index) {
      if (index == 0) {
        return "";
      } else {
        return `left: ${index * -10}px; position: relative`;
      }
    },
  },
};
</script>

<style scoped>
.grid-4 {
  display: grid;
  grid-template-columns: 7px 25% 25% 25% 25%;
  margin-top: 10px;
  height: 79px;
  border: 1px solid #e2e4ea;
  border-radius: 10px;
  overflow: hidden;
  transition: border-color .15s ease, box-shadow .15s ease, transform .15s ease;
}
.grid-4:hover {
  border-color: rgba(108, 48, 204, 0.28);
  box-shadow: 0 4px 14px rgba(17, 24, 39, 0.06);
  transform: translateY(-1px);
}
.duplicate-pill {
  margin-left: 14px;
  cursor: pointer;
}
/* Primary purple action — list-page Add buttons */
.btn-primary-purple.el-button {
  background-color: #6c30cc;
  border-color: #6c30cc;
  color: #ffffff;
  font-weight: 700;
  letter-spacing: 0.02em;
  transition: background-color .15s ease, border-color .15s ease, box-shadow .15s ease;
}
.btn-primary-purple.el-button:hover,
.btn-primary-purple.el-button:focus {
  background-color: #5a25b0;
  border-color: #5a25b0;
  color: #ffffff;
  box-shadow: 0 4px 14px rgba(108, 48, 204, 0.18);
}
/* Neutral secondary action */
.btn-secondary.el-button {
  background-color: #ffffff;
  border-color: #e2e4ea;
  color: #4a4a4a;
  font-weight: 700;
  letter-spacing: 0.02em;
  transition: background-color .15s ease, border-color .15s ease, color .15s ease;
}
.btn-secondary.el-button:hover,
.btn-secondary.el-button:focus {
  background-color: #f6f7f9;
  border-color: #d4d7de;
  color: #2f2f2f;
}
.divContent {
  background: #ffffff;
}
.el-submenu {
  width: 220px;
}
.txtSubOption {
  font-size: 14px;
  width: 220px;
}
.txtOption {
  color: #4a4a4a;
  font-size: 14px;
  margin-left: 16px;
  width: 158px;
  display: inline-block;
}
.el-dropdown-menu__item {
  font-size: 14px;
  font-weight: 500;
  color: #585858;
}
li.el-dropdown-menu__item:hover {
  background-color: #6c30cc;
  color: #ffffff;
}
div.el-dropdown {
  padding-left: 0px;
}
.image-profile-32 {
  border: 1px solid #ffffff;
}
.overflow-chip {
  background: #ffffff !important;
  border: 1px solid rgba(108, 48, 204, 0.28);
  box-shadow: 0 1px 3px rgba(108, 48, 204, 0.10);
}
.overflow-chip > .text-in-image {
  color: #6c30cc;
  text-shadow: none;
  letter-spacing: 0.02em;
}
.duplicateStyle {
  background: #fff4f4;
  border-color: rgba(204, 48, 48, 0.28);
}
.team-sitebar {
  border-radius: 0;
  opacity: 1;
  height: 100%;
}
.first-column {
  background-color: #f8f8f8;
  height: 880px;
  border-radius: 3px 0 0 3px;
}
.second-column {
  height: 880px;
}
.txtHeaderStyle {
  margin: 0px;
  padding-bottom: 10px;
  font-size: 11px;
  font-weight: 700;
  color: #8a8a8a;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.tagColor {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 8px;
  border: 2px solid transparent;
  box-shadow: 0 1px 2px rgba(17, 24, 39, 0.08);
  transition: transform .15s ease, box-shadow .15s ease;
}
.tagColor:hover {
  transform: scale(1.08);
  box-shadow: 0 4px 12px rgba(17, 24, 39, 0.12);
}
.tagColor.active-check {
  border-color: #ffffff;
  box-shadow: 0 0 0 2px #6c30cc, 0 4px 12px rgba(108, 48, 204, 0.18);
}
.bg- {
  background: #747474;
}
.active-check {
  background-image: url("../../assets/images/outline-check-18px@2x.png");
  background-repeat: no-repeat;
  background-size: 30px 30px;
}
.btnAddTeamModal {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  width: 176px;
  height: 50px;
  font-size: 15px;
  font-weight: 700;
}
.btnAddTeamModal:hover {
  background-color: #32c2d5;
  border-color: #32c2d5;
  color: #ffffff;
  opacity: 0.6;
}
.btnCancelTeamModal {
  min-width: 122px;
  height: 50px;
  padding: 0 16px;
  white-space: nowrap;
  font-size: 15px;
  font-weight: 700;
}
.guideTextModal {
  font-size: 16px;
  font-weight: 700;
  color: #000000;
  opacity: 0.65;
  word-break: normal;
}
.sidebar-modal-color {
  content: "";
  position: absolute;
  border-radius: 2px 0 0 2px;
  height: 100%;
  top: 0;
  left: 0;
  width: 14px;
}
.btn-cancel-color {
  background-color: #747474;
}
.style-internal-value {
  height: 44px;
  background-color: #f6f7f9;
  border: 1px solid #e2e4ea;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #4a4a4a;
  padding: 0 18px;
  cursor: pointer;
  transition: background-color .15s ease, border-color .15s ease;
}
.style-internal-value:hover {
  background-color: #eef0f5;
  border-color: #d4d7de;
  color: #2f2f2f;
}
.child-teams-list {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 2px 0 6px;
  scrollbar-width: thin;
}
.child-teams-list::-webkit-scrollbar {
  height: 6px;
}
.child-teams-list::-webkit-scrollbar-thumb {
  background: rgba(17, 24, 39, 0.15);
  border-radius: 999px;
}
.child-team-chip {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 5px 10px;
  background: #f6f7f9;
  border: 1px solid #e2e4ea;
  border-radius: 999px;
  flex: 0 0 auto;
}
.child-team-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex: 0 0 auto;
  box-shadow: 0 0 0 1px rgba(17, 24, 39, 0.06);
}
.child-team-name {
  font-size: 13px;
  font-weight: 600;
  color: #1f2330;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 220px;
}
.color-tag-swatches {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 0;
}
.goals-shortcut {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #6c30cc;
  text-decoration: none;
  letter-spacing: 0.01em;
  transition: color .15s ease, gap .15s ease;
}
.goals-shortcut:hover,
.goals-shortcut:focus {
  color: #5a25b0;
  gap: 8px;
  text-decoration: none;
}
.goals-shortcut-arrow {
  font-size: 14px;
  line-height: 1;
}
</style>
<style lang="scss">
#tabTeams .el-submenu__title {
  height: 40px;
  line-height: 40px;
  border-radius: 4px 0 0 4px;
  background-color: #f4f4f4;
}
#tabTeams .el-table__header-wrapper {
  padding-top: 12px;
}
#tabTeams .el-table .cell {
  line-height: 17px;
}
#tabTeams .el-table th > .cell {
  font-weight: 700;
}
#tabTeams .el-table td {
  padding: 9px 0px;
}
#tabTeams span.el-checkbox__inner::after {
  border: 3px solid #fff;
  border-left: 0;
  border-top: 0;
  left: 6px;
  width: 6px;
  height: 13px;
}
#tabTeams label.el-checkbox {
  line-height: 24px;
}
#tabTeams .el-checkbox__input {
  zoom: 1 !important;
}
#tabTeams .el-dialog {
  border-radius: 3px;
  width: 1100px;
}
#tabTeams .el-dialog__header {
  padding: 0px;
}
#tabTeams .el-dialog__body {
  padding: 0px;
  height: 880px;
  border-radius: 3px;
}
#tabTeams .profileform .team-field .el-input__inner {
  height: 46px;
  font-size: 18px;
  font-weight: 400;
}
#tabTeams .el-input.is-disabled.disable .el-input__inner {
  background-color: #f5f5fa;
  border-color: #e2e4ea;
}
#tabTeams .profileform .team-parent-field .el-input__inner {
  height: 52px;
  background: #ffffff;
  border: 1px solid #e2e4ea;
  border-left-width: 4px;
  border-left-style: solid;
  border-radius: 10px;
  padding: 0 18px;
  font-size: 15px;
  font-weight: 600;
  color: #1f2330;
  opacity: 1;
  transition: border-color .15s ease, box-shadow .15s ease;
}
#tabTeams .profileform .team-parent-field .el-input__inner:hover {
  border-color: #d4d7de;
}
#tabTeams .profileform .team-parent-field .el-input__inner:focus {
  border-color: #6c30cc;
  box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.12);
}
#tabTeams .profileform .team-parent-field input::placeholder {
  color: #8a8a8a;
  opacity: 1;
  font-weight: 500;
}
#tabTeams .parent-hint {
  margin: 8px 0 0 0;
  padding: 0;
  font-size: 12px;
  font-weight: 400;
  color: #747474;
  line-height: 1.4;
  font-style: italic;
}
.el-autocomplete-suggestion .parent-suggestion {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
}
.el-autocomplete-suggestion .parent-suggestion-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex: 0 0 auto;
  box-shadow: 0 0 0 1px rgba(17, 24, 39, 0.06);
}
.el-autocomplete-suggestion .parent-suggestion-name {
  font-size: 14px;
  color: #1f2330;
  font-weight: 500;
}
#tabTeams .profileform .border-left-color- .el-input__inner {
  border-left-color: #747474;
}
#tabTeams .profileform .border-left-color-6C30CC .el-input__inner {
  border-left-color: #6c30cc;
}
#tabTeams .profileform .border-left-color-4F86C6 .el-input__inner {
  border-left-color: #4f86c6;
}
#tabTeams .profileform .border-left-color-50B0C6 .el-input__inner {
  border-left-color: #50b0c6;
}
#tabTeams .profileform .border-left-color-379392 .el-input__inner {
  border-left-color: #379392;
}
#tabTeams .profileform .border-left-color-68D5B5 .el-input__inner {
  border-left-color: #68d5b5;
}
#tabTeams .profileform .border-left-color-EE7885 .el-input__inner {
  border-left-color: #ee7885;
}
#tabTeams .profileform .border-left-color-C99EC4 .el-input__inner {
  border-left-color: #c99ec4;
}
#tabTeams .profileform .border-left-color-84B1ED .el-input__inner {
  border-left-color: #84b1ed;
}
#tabTeams .profileform .border-left-color-31AADE .el-input__inner {
  border-left-color: #31aade;
}
#tabTeams .profileform .border-left-color-F0DC05 .el-input__inner {
  border-left-color: #f0dc05;
}
#tabTeams .profileform .border-left-color-E63A40 .el-input__inner {
  border-left-color: #e63a40;
}

/* Cosmetic polish: create/edit Team dialog (scoped to .tm-modal) */
.el-dialog.tm-modal {
  .el-input__inner,
  .el-textarea__inner {
    border: 1px solid #e2e4ea;
    border-radius: 10px;
    transition: border-color .15s ease, box-shadow .15s ease;
  }
  .el-input__inner:focus,
  .el-textarea__inner:focus {
    border-color: #6c30cc;
    box-shadow: 0 0 0 3px rgba(108, 48, 204, 0.12);
  }
  .btnAddTeamModal,
  .btnAddTeamModal.el-button {
    background-color: #6c30cc !important;
    border-color: #6c30cc !important;
    color: #ffffff !important;
    border-radius: 10px;
    letter-spacing: 0.04em;
  }
  .btnAddTeamModal:hover,
  .btnAddTeamModal.el-button:hover {
    background-color: #5a25b0 !important;
    border-color: #5a25b0 !important;
    box-shadow: 0 6px 16px rgba(108, 48, 204, 0.18);
    opacity: 1;
  }
  /* Edit-mode Delete button: subtle danger, not a heavy gray slab */
  .btnCancelTeamModal[type="primary"],
  .btnCancelTeamModal.btn-gray {
    background-color: rgba(204, 48, 48, 0.08) !important;
    border: 1px solid rgba(204, 48, 48, 0.28) !important;
    color: #cc3030 !important;
    border-radius: 10px;
    letter-spacing: 0.04em;
  }
  .btnCancelTeamModal[type="primary"]:hover,
  .btnCancelTeamModal.btn-gray:hover {
    background-color: rgba(204, 48, 48, 0.14) !important;
    border-color: rgba(204, 48, 48, 0.42) !important;
    color: #b62a2a !important;
  }
  .btnCancelTeamModal[type="primary"].is-disabled,
  .btnCancelTeamModal.btn-gray.is-disabled,
  .btnCancelTeamModal[type="primary"][disabled],
  .btnCancelTeamModal.btn-gray[disabled] {
    background-color: #f4f5f8 !important;
    border-color: #e2e4ea !important;
    color: #b4b4b4 !important;
    cursor: not-allowed;
  }
  .el-switch.is-checked .el-switch__core {
    background-color: #6c30cc;
    border-color: #6c30cc;
  }
  .el-radio.is-checked .el-radio__label {
    color: #6c30cc;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background: #6c30cc;
    border-color: #6c30cc;
  }
}
</style>
